import de from 'vee-validate/dist/locale/de.json'

export default {
  'Welcome back!': 'Willkommen zurück!',
  'Try Valuator for free!': 'Testen Sie Valuator kostenlos!',
  appDescription: `
    <p class="mb-2">In den ersten 30 Tagen ist Valuator vollständig kostenlos, und Sie können sich in dieser Zeit davon überzeugen, wie es Ihnen hilft, den Beschaffungsprozess zu organisieren.</p>
    <p class="mb-2">Einfache Kommunikation mit Lieferanten, das Senden von Angebotsanfragen mit einem Klick, sortierte und übersichtliche eingegangene Angebote, Analysen, Berichterstellung und die einfache Auswahl des besten Angebots.</p>
    <p class="mb-2">Valuator – alles an einem Ort.</p>
  `,
  loginAppDescription: 'Einfache Kommunikation mit eigenen Lieferanten, das Senden von Angebotsanfragen, klare Übersicht aller eingegangenen Angebote, Auswahl des besten, Analysen, Berichterstellung. Alles an einem Ort.',
  'Forgot Password?': 'Passwort vergessen?',
  'Do not have an account?': 'Haben Sie kein Konto?',
  'Create an account': 'Ein Konto erstellen',
  'Make an account': 'Ein Konto erstellen',
  'Already have an account?': 'Haben Sie bereits ein Konto?',
  'Sign in instead': 'Anmelden',
  'I agree to': 'Ich stimme zu',
  'Remember Me': 'Angemeldet bleiben',
  Attach: 'Anhängen',
  'Advanced payment': 'Vorauszahlung',
  'Partial payment': 'Teilzahlung',
  'Final payment': 'Endzahlung',
  'Advanced': 'Vorauszahlung',
  'Partial': 'Teilweise',
  'Final': 'Endgültig',
  Login: 'Anmelden',
  Logout: 'Abmelden',
  Home: 'Startseite',
  Documents: 'Dokumente',
  Add: 'Hinzufügen',
  Cancel: 'Abbrechen',
  Delete: 'Löschen',
  Upload: 'Hochladen',
  Edit: 'Bearbeiten',
  View: 'Ansehen',
  Save: 'Speichern',
  Send: 'Senden',
  Profile: 'Profil',
  Confirm: 'Bestätigen',
  Description: 'Beschreibung',
  Service: 'Dienstleistung',
  Category: 'Kategorie',
  Company: 'Unternehmen',
  Files: 'Zusätzliche Dokumente',
  PIB: 'USt-IdNr.',
  Accept: 'Akzeptieren',
  Reject: 'Ablehnen',
  'Deadline for response': 'Antwortfrist',
  'Delivery deadline': 'Lieferfrist',
  'Select status': 'Status auswählen',
  'Select category': 'Kategorie auswählen',
  'Delivery date': 'Lieferdatum',
  Back: 'Zurück',
  'No data available': 'Keine Daten verfügbar',
  'Terms of Condition': 'Nutzungsbedingungen',
  Close: 'Schließen',
  Yes: 'Ja',
  No: 'Nein',
  Status: 'Status',
  'Created at': 'Erstellt am',
  Finances: 'Finanzen',
  'Finances overview': 'Finanzübersicht',
  'Select files': 'Dateien auswählen',
  'Please select files before uploading': 'Bitte wählen Sie Dateien vor dem Hochladen aus',
  'Files uploaded successfully': 'Dateien erfolgreich hochgeladen',

  purchaseStatuses: {
    Active: 'Aktiv',
    Valuation: 'Bewertung',
    Closed: 'Geschlossen',
    Canceled: 'Storniert',
    Initiated: 'Initiierung',
    'Initiation approved': 'Initiierung genehmigt',
    Requested: 'Angeforderte Anfrage',
    Received: 'Erhaltene Ware / Dienstleistung',
    Paid: 'Bezahlt',
    'Ad hoc': 'Ad hoc',
    Locked: 'Geschlossen - Ware geliefert',
    'Ad hoc approved': 'Ad hoc - Genehmigt',
  },
  Active: 'Aktiv',
  Closed: 'Geschlossen',
  'Cancel request': 'Anfrage stornieren',

  SuppliersEmptyText: '',
  Suppliers: 'Lieferanten',
  Supplier: 'Lieferant',
  'Select supplier': 'Lieferant auswählen',
  'Select sector': 'Sektor auswählen',
  Categories: 'Kategorien',
  'Categories overview': 'Kategorienübersicht',
  'All suppliers': 'Alle Lieferanten',
  Warehouse: 'Lager',
  Receipts: 'Empfangsbelege',

  Procurement: 'Beschaffung',
  Procurements: 'Beschaffungen',
  'Procurements overview': 'Beschaffungsübersicht',
  Request: 'Anfrage',
  Number: 'Nr.',
  Offers: 'An Lieferanten gesendet/Eingegangene Angebote',
  Offer: 'Angebot',
  'New request': 'Neue Anfrage',
  'Requests overview': 'Anfrageübersicht',
  'Closed requests': 'Geschlossene Anfragen',
  'Confirmed requests': 'Bestätigte Anfragen',
  'Privacy policy': 'Datenschutzrichtlinie',
  'Format exm.': 'Format z.B.: +491752013555',

  successRegistrationMessage: 'Die Registrierung war erfolgreich. Überprüfen Sie Ihre E-Mails, wir haben Ihnen einen Link zur Bestätigung geschickt.',

  'New category': 'Neue Kategorie',
  'Add new category': 'Neue Kategorie hinzufügen',
  'Edit category': 'Kategorie bearbeiten',
  'Confirm deletion': 'Löschung bestätigen',
  confirmDeletionQuestion: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  'Yes, delete it': 'Ja, löschen',
  'No, just kidding': 'Abbrechen',
  'New supplier': 'Neuer Lieferant',
  'Add new supplier': 'Neuen Lieferanten hinzufügen',
  'Edit supplier': 'Lieferanten bearbeiten',
  'New contact person': 'Neue Kontaktperson',
  'Save contact person': 'Kontaktperson speichern',
  'Update contact person': 'Kontaktperson aktualisieren',
  Price: 'Preis',
  Received: 'Erhaltene Ware / Dienstleistung',
  'Offer Pending': 'Ausstehend',
  'Offer Link opened': 'Link geöffnet',
  'Offer Offer sent': 'Angebot gesendet',
  'Offer Accepted': 'Angebot akzeptiert',
  'Offer Confirmed': 'Angebot bestätigt',
  'Offer Rejected': 'Angebot abgelehnt',
  'Cancellation Reason': 'Stornierungsgrund',
  'Enter reason for cancellation': 'Geben Sie den Stornierungsgrund ein',
  'Initiation Approved': 'Initiierung genehmigt',
  'Initiation Rejected': 'Initiierung abgelehnt',
  'Purchase Requested': 'Anfrage vorgeschlagen',
  'Purchase Active': 'Aktiv',
  'Purchase Rejected': 'Abgelehnt',
  'Purchase Valuation': 'Bewertung',
  'Purchase Closed': 'Geschlossen',
  'Purchase Canceled': 'Storniert',
  'Purchase Initiated': 'Initiiert',
  'Purchase Active Home': 'Aktive Anfragen',
  'Purchase Valuation Home': 'Anfragen in Bewertung',
  'Purchase Closed Home': 'Geschlossene Anfragen',
  'Purchase Canceled Home': 'Stornierte Anfragen',
  'Bid value Home': 'Gesamtwert aller Beschaffungen',
  'Accepted offers Home': 'Angenommene Angebote',
  'Active suppliers Home': 'Aktive Lieferanten',
  'Internal note': 'Interne Notiz',
  'Failed to upload note': 'Fehler beim Hochladen der internen Notiz',
   Note: 'Notiz',
   Quantity: 'Menge',
   Accepted: 'Akzeptiert',
   of: 'von',
   Undo: 'Rückgängig machen',
  'Confirm request': 'Anfrage bestätigen',
  'Request is closed': 'Anfrage ist geschlossen',
  'Request is canceled': 'Anfrage ist storniert',
  'Request sent for verification': 'Anfrage zur Überprüfung gesendet',
  'By month': 'Nach Monat',
  'By week': 'Nach Woche',
  'By category': 'Nach Kategorie',
  'Number of purchases by month': 'Anzahl der Beschaffungen nach Monat',
  'Number of purchases by week': 'Anzahl der Beschaffungen nach Woche',
  'Number of purchases by category': 'Anzahl der Beschaffungen nach Kategorie',
  'Number of purchases by supplier': 'Anzahl der Beschaffungen pro Lieferant',
  'Number of purchases by customer': 'Anzahl der Beschaffungen pro Kunde',
  'Consumption by month': 'Wert der Beschaffungen nach Monat',
  'Consumption by week': 'Wert der Beschaffungen nach Woche',
  'Minimum and maximum value by category': 'Min- und Max-Wert der Beschaffungen nach Kategorie',
  'Minimum and maximum value by month': 'Min- und Max-Wert der Beschaffungen nach Monat',
  'Total consumption by category': 'Gesamtwert der Beschaffungen nach Kategorie (Zeitraum)',
  'Chart type': 'Diagrammtyp',
  'View type': 'Ansichtstyp',
  'Minimum and maximum value for purchase': 'Minimal- und Maximalwert für Beschaffung',
  'Procurement number': 'Beschaffungsnummer',
  'Choose number of procurement': 'Wähle Beschaffungsnummer',
  'Add supplier': 'Lieferant hinzufügen',
  'View suppliers': 'Lieferanten ansehen',
  'There are no suppliers in this category': 'In dieser Kategorie gibt es derzeit keine Lieferanten',
  'View categories': 'Kategorien ansehen',
  'User management': 'Benutzerverwaltung',
  Users: 'Benutzer',
  'Create user': 'Benutzer erstellen',
  'All users': 'Alle Benutzer',
  'Are you confirming the deletion of the user': 'Bestätigen Sie die Löschung des Benutzers',
  'Edit user': 'Benutzer bearbeiten',
  'Can confirm purchase': 'Kann Beschaffung bestätigen',
  'Select role': 'Rolle auswählen',
  'Are you sure you want to confirm the request': 'Sind Sie sicher, dass Sie die Anfrage bestätigen möchten',
  'Are you sure you want to submit a request for approval': 'Sind Sie sicher, dass Sie die Anfrage zur Genehmigung einreichen möchten',
  'Send for approval': 'Zur Genehmigung senden',
  'Purchase management': 'Beschaffungsmanagement',
  'Purchase confirmation': 'Beschaffungsbestätigung',
  'Date from': 'Datum von',
  'Date to': 'Datum bis',
  'Transportation included': 'Transport inbegriffen',
  'Transportation not included': 'Transport nicht inbegriffen',
  'Maximum amount to confirm': 'Maximaler Betrag zur Bestätigung',
  Budget: 'Budget',
  Budgets: 'Budgets',
  budgetFor: '{categories} von {totalCategories} Kategorien',
  'Budgets overview': 'Budgetübersicht',
  'Create budget': 'Budget erstellen',
  'Edit budget': 'Budget bearbeiten',
  'You have successfully created a budget': 'Sie haben erfolgreich ein Budget erstellt',
  'Select an existing contact person': 'Wählen Sie eine bestehende Kontaktperson aus',
  'Add category': 'Kategorie hinzufügen',
  'Can view the budget': 'Kann das Budget ansehen',
  'Duplicate request': 'Anfrage duplizieren',
  Articles: 'Artikel',
  Name: 'Name',
  'Order number': 'Bestellnummer',
  'Unit price': 'Einzelpreis',
  'Quantity requested': 'Angeforderte Menge',
  'Quantity offered': 'Angebotene Menge',
  Projected: 'Prognostiziert',
  Spent: 'Ausgegeben',
  'Number / Value': 'Anzahl / Wert',
  Amount: 'Betrag',
  'Comprehensive data from the platform': 'Umfassende Daten von der Plattform',
  'Forgot your password?': 'Passwort vergessen?',
  'Enter your email and we will send you instructions for recovering a forgotten password': 'Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen Anweisungen zum Wiederherstellen eines vergessenen Passworts',
  'Return to login page': 'Zurück zur Anmeldeseite',
  'Choose avatar': 'Avatar auswählen',
  'Edit Profile': 'Profil bearbeiten',
  Email: 'E-Mail',
  Phone: 'Telefon',
'Change avatar': 'Avatar ändern',
'Change your password': 'Passwort ändern',
'Password must contain at least 8 characters, one special character, one number, one uppercase and one lowercase letter.': 'Das Passwort muss mindestens 8 Zeichen, ein Sonderzeichen, eine Zahl, einen Groß- und einen Kleinbuchstaben enthalten.',
'Company information': 'Unternehmensdaten',
'Request description': 'Anfragenbeschreibung',
'Request service': 'Dienstleistung beschreiben',
'Describe your request': 'Beschreiben Sie Ihre Anfrage',
'Describe your service': 'Beschreiben Sie Ihre Dienstleistung',
'Do you confirm the deletion': 'Bestätigen Sie die Löschung',
'Do you confirm the deletion of the offer': 'Bestätigen Sie die Löschung des Angebots',
'Are you sure you want to update the offer': 'Sind Sie sicher, dass Sie das Angebot aktualisieren möchten',
'Are you sure you want to submit an offer': 'Sind Sie sicher, dass Sie ein Angebot einreichen möchten',
'Do you confirm the deletion of the category': 'Bestätigen Sie die Löschung der Kategorie',
'Do you confirm the deletion of the supplier': 'Bestätigen Sie die Löschung des Lieferanten',
'Do you confirm the deletion of the user': 'Bestätigen Sie die Löschung des Benutzers',
'You have successfully submitted your request': 'Sie haben Ihre Anfrage erfolgreich eingereicht',
'Wrong PIB code entered': 'Falscher PIB-Code eingegeben.',
'Verification is required to place an offer': 'Eine Verifizierung ist erforderlich, um ein Angebot abzugeben',
'Please enter your PIB': 'Bitte geben Sie Ihren PIB ein',

"Instructions": "Anweisungen",
  "Once the offer has been left, you can update it until the customer confirms the purchase.": "Sobald das Angebot abgegeben wurde, können Sie es aktualisieren, bis der Kunde den Kauf bestätigt.",
  "Your offer": "Ihr Angebot",
  "Total price": "Gesamtpreis",
  "Requested qty.": "Angeforderte Menge",
  "Action confirmation": "Aktionsbestätigung",
  "You have successfully submitted an offer.": "Sie haben erfolgreich ein Angebot eingereicht.",
  "You have successfully modified your offer.": "Sie haben Ihr Angebot erfolgreich geändert.",
  "The supplier has not opened the request.": "Der Lieferant hat die Anfrage noch nicht geöffnet.",
  "Send again": "Erneut senden",
  "The supplier has opened a request but has not yet sent a bid.": "Der Lieferant hat die Anfrage geöffnet, aber noch kein Angebot abgegeben.",
  "Are you sure you want to accept the offer": "Sind Sie sicher, dass Sie das Angebot annehmen möchten?",
  "Are you sure you want to decline the offer": "Sind Sie sicher, dass Sie das Angebot ablehnen möchten?",
  "Are you sure you want to resend the request to the supplier": "Sind Sie sicher, dass Sie die Anfrage erneut an den Lieferanten senden möchten?",
  "Are you sure you want to cancel the offer": "Sind Sie sicher, dass Sie das Angebot stornieren möchten?",
  "Are you sure you want to cancel the request": "Sind Sie sicher, dass Sie die Anfrage stornieren möchten?",
  "Procurement has expired": "Die Beschaffung ist abgelaufen.",
  "You can no longer bid on this procurement.": "Sie können nicht mehr auf diese Beschaffung bieten.",
  "Procurement history for the period (number/value)": "Beschaffungsverlauf für den Zeitraum (Anzahl/Wert)",
  footerNav: {
    "All rights Reserved": "Alle Rechte vorbehalten",
    "Terms of use": "Nutzungsbedingungen",
    "Privacy policy": "Datenschutzrichtlinie",
    "Cookie policy": "Cookie-Richtlinie"
  },
  "Currency": "Währung",
  "You have successfully added a category. You can now add a supplier.": "Sie haben erfolgreich eine Kategorie hinzugefügt. Sie können nun einen Lieferanten hinzufügen.",
  registerSuccess: {
    "title": "Registrierung erfolgreich!",
    "errorTitle": "Registrierung fehlgeschlagen",
    "description": "Sie haben sich erfolgreich registriert. <strong>Überprüfen Sie Ihre E-Mail</strong>, wir haben Ihnen einen Bestätigungslink gesendet."
  },
  "createUserSuccessfulMessage": "Sie haben den Benutzer erfolgreich erstellt.",
  "newPasswordSentOnMail": "Ein neues Passwort wurde Ihnen per E-Mail gesendet. Sie werden nun zur Anmeldeseite weitergeleitet.",
  "anErrorHasOccurred": "Es ist ein Fehler aufgetreten.",
  "sendingInProcess": "Senden läuft...",
  "passwordReset": "Passwort zurücksetzen",
  "confirmationLinkSentToEmail": "Der Bestätigungslink wurde an Ihre E-Mail gesendet.",
  "Role": "Rolle",
  "Details": "Details",
  "General": "Allgemein",
  "Security": "Sicherheit",
  "Address": "Adresse",
  "contractFileName": "Beschaffung",
  "Confirmation": "Bestätigung",

  units: {
    "kg": "kg",
    "m": "m",
    "m2": "m²",
    "m3": "m³",
    "t": "t",
    "pieces": "Stück",
    "l": "l"
  },

  chartsFilters: {
    "title": "Filter",
    "buttonText": "Filter anwenden",
    offersStatuses: {
      "acceptedOffers": "Akzeptierte Angebote",
      "declinedOffers": "Abgelehnte Angebote"
    },
    noValues: {
      "numberOffer": "Anzahl der Angebote",
      "valueOffer": "Wert der Angebote"
    }
  },
  instructions: {
    "title": "Was soll ich jetzt tun?!",
    step01: {
      "title": "Schritt: Kategorien erstellen!",
      "description": "(Sie können eine unbegrenzte Anzahl von Kategorien für Waren und Dienstleistungen, die Sie beschaffen, erstellen)"
    },
    step02: {
      "title": "Schritt: Lieferanten für die erstellten Kategorien hinzufügen!",
      "description": "(Sie können für jede Kategorie eine unbegrenzte Anzahl von Lieferanten hinzufügen)"
    },
    step03: {
      "title": "Schritt: Beschaffung ausschreiben!",
      "description": "(Durch die Erstellung einer Beschaffungsanfrage erhalten die Lieferanten alle notwendigen Informationen, um erfolgreich auf Ihre Anfrage zu reagieren)"
    },
    step04: {
      "title": "Schritt: Wählen Sie das beste Angebot aus!",
      "description": "(Sehen Sie sich die eingegangenen Angebote der Lieferanten an und wählen Sie das beste aus)"
    },
    step05: {
      "title": "Ende!"
    }
  },
  "passwordSuccessfullyChanged": "Das Passwort wurde erfolgreich geändert.",
  "imageReplacedSuccessfully": "Das Bild wurde erfolgreich ersetzt.",
  "youHaveSuccessfullyChangedTheContactPerson": "Sie haben die Kontaktperson erfolgreich geändert.",
  "dataChangedSuccessfully": "Die Daten wurden erfolgreich geändert.",
  "confirmationRegistrationSuccessfully": "Die Registrierung wurde erfolgreich bestätigt!",
  "confirmationRegistrationFailed": "Die Registrierung konnte nicht bestätigt werden!",
  "confirmationRegistrationMessage": "Eine Benachrichtigung wird an die registrierte E-Mail-Adresse gesendet, sobald der Moderator Ihr Konto aktiviert hat. Danach können Sie sich im System anmelden.",
  orderPlan: {
    "title": "Paket bestellen",
    "month": "Monat",
    "months": "Monate",
    "preorderType": "Vorausrechnungstyp",
    "selectedPlan": "Ausgewähltes Paket",
    "order": "Bestellen",
    "serbia": "Serbien",
    "ino": "International",
    "confirmationQuestion": "Sind Sie sicher, dass Sie das Paket bestellen möchten?",
    "successfulMessage": "Sie haben das Paket erfolgreich bestellt. Eine Vorausrechnung wurde an Ihre E-Mail-Adresse gesendet."
  },
  genders: {
    "all": "ALLE",
    "m": "M",
    "f": "W"
  },
  register: {
    snackbarPib: {
      "text": "Möchten Sie die Unternehmensdaten ausfüllen?",
      "yes": "Ja",
      "no": "Nein"
    }
  },
  "registrationNumber": "Registrierungsnummer",
  affiliate: {
    "inviteButton": "Einladen",
    affiliateInfo: {
      "text": "Ihr Affiliate-Link",
      "copy": "Kopieren",
      "copiedLinkText": "Der Affiliate-Link wurde kopiert."
    },
    userInfo: {
      "title": "Ihre Informationen",
      "name": "Name",
      "email": "E-Mail",
      "phoneNumber": "Telefonnummer",
      "contractNumber": "Vertragsnummer",
      "companyName": "Firmenname",
      "pib": "Steuernummer",
      "registrationNumber": "Registrierungsnummer"
    },
    affiliateTable: {
      "title": "Affiliate-Benutzer",
      "trialPeriodExpired": "Abgelaufen",
      "validUntil": "Gültig bis"
    },
    inviteModal: {
      "title": "Benutzer einladen",
      "infoTextLimit": "Sie können bis zu 10 Einladungen gleichzeitig senden.",
      "emailsToInvite": "E-Mail-Adressen zum Einladen",
      "addEmailToInvite": "Fügen Sie E-Mail-Adressen zum Einladen hinzu",
      "successMessage": "Sie haben die Benutzer erfolgreich eingeladen."
    },
    companyDetailsModal: {
      "title": "Details",
      "pib": "Steuernummer",
      "registrationNumber": "Registrierungsnummer",
      "address": "Adresse"
    },
    profitDetailsDialog: {
      "title": "Profitübersicht",
      "transaction": "Transaktion",
      "package": "Paket",
      "amount": "Betrag",
      "share": "Anteil",
      "paidOff": "Ausbezahlt",
      "noTransactionsMessage": "Es gibt noch keine Transaktionen."
    },
    commentDialog: {
      "title": "Kommentar"
    },
    dialogNote: {
      "title": "Notiz"
    }
  },
  faq: {
    "faq01": "Wie füge ich Kategorien und Lieferanten hinzu?",
    "faq02": "Wie starte ich eine Beschaffung?",
    "faq03": "Wie erstelle ich Benutzer?"
  },
  "switchToApp": "Wechseln Sie zur Anwendung",
  "switchToMarketplace": "Wechseln Sie zum Marktplatz",
  "customer": "Kunde",
  "offerDate": "Beschaffungsdatum",
  "addInvoice": "Rechnung hinzufügen",
  "addAccounting": "Vorausrechnung hinzufügen",
  "addHocPurchase": "Ad-hoc-Beschaffung",
  "directPurchase": "Direkte Beschaffung",
  "Create Ad hoc purchase": "Ad-hoc-Beschaffung erstellen",
  "Create direct purchase": "Direkte Beschaffung erstellen",
  "Storekeeper": "Lagerverwalter",
  "Ad hoc purchase": "Ad-hoc-Beschaffungen",
  "Direct purchase": "Direkte Beschaffungen",
  "Direct purchase created": "Direkte Beschaffung erstellt",
  "Direct purchase approved": "Direkte Beschaffung bestätigt",
  "Direct purchase delivered": "Direkte Beschaffung geliefert",
  "Direct Procurement History": "Historie direkter Beschaffungen",
  "Ad hoc": "Ad hoc",
  "Ad hoc approved": "Ad hoc - bestätigt",
  "Paid": "Bezahlt",
  "Invoice": "Rechnung",
  "Accounting": "Vorausrechnung",
  "Purchase order": "Bestellung",
  "On hold": "In Bearbeitung",
  "Date for document": "Datum des Dokuments",
  "Supplier documents": "Lieferantendokumente",
  "Add document": "Dokument hinzufügen",
  "File name": "Dateiname",
  "Document name": "Dokumentenname",
  "Document description": "Dokumentenbeschreibung",
  "Contract End Date": "Vertragsenddatum",
  "Update": "Aktualisieren",
  "Please select files before uploading": "Bitte wählen Sie Dateien aus, bevor Sie sie hochladen",
  "Files uploaded successfully": "Dateien erfolgreich hochgeladen",
  "Failed to upload attachments": "Anhänge konnten nicht hochgeladen werden",
  "Document updated successfully": "Dokument erfolgreich aktualisiert",
  "Failed to update document": "Dokument konnte nicht aktualisiert werden",
  "Failed to download file": "Datei konnte nicht heruntergeladen werden",
  "Select files": "Dateien auswählen",
  "Date for receipt": "Empfangsdatum",
  "Additional information": "Zusätzliche Informationen",
  "Realization suggestion rejected": "Umsetzungsvorschlag abgelehnt",
  "History of negotiation": "Verhandlungshistorie",
  "Date": "Datum",
  "User": "Benutzer",
  "Time": "Zeit",
  "Request for supply": "Anfrage zur Beschaffung",
  "Procurement history": "Beschaffungshistorie",
  "Ad hoc Procurement History": "Ad-hoc-Beschaffungshistorie",
  "Procurement initiated": "Beschaffung initiiert",
  "Ad hoc purchase created": "Ad-hoc-Beschaffung erstellt",
  "Ad hoc purchase approved": "Ad-hoc-Beschaffung bestätigt",
  "Initiation approved": "Initiierung genehmigt",
  "Procurement request proposed": "Beschaffungsanfrage vorgeschlagen",
  "Procurement announced": "Beschaffung angekündigt",
  "Implementation proposed": "Umsetzung vorgeschlagen",
  "Procurement completed": "Beschaffung abgeschlossen",
  "Goods / services received in the warehouse": "Waren / Dienstleistungen im Lager erhalten",
  "Goods / services paid": "Waren / Dienstleistungen bezahlt",
  "Reason for rejection": "Ablehnungsgrund",
  "Negotiate": "Verhandeln",
  "Attach the delivery note": "Lieferschein anhängen",
  "Initiate": "Initiieren",
  "Message": "Nachricht",
  "Do you confirm": "Bestätigen Sie",
  "Select the purchase value": "Wählen Sie den Beschaffungswert aus",
  "Up to four thousand euros": "Bis zu viertausend Euro",
  "More than four thousand euros": "Mehr als viertausend Euro",
  "Purchase confirmation no.": "Bestätigung der Beschaffung Nr.",
  "Are you sure": "Sind Sie sicher",
  "Mark as paid": "Als bezahlt markieren",
  "Approve purchase": "Beschaffung genehmigen",
  "Deliver": "Liefern",
  "Advance payment": "Vorauszahlung",
  "Choose a payment type": "Wählen Sie eine Zahlungsart",
  "Standard payment": "Standardzahlung",
  "Advanced payment": "Vorauszahlung",
  "Payment method": "Zahlungsmethode",
  "Locked": "Geschlossen - Waren geliefert",

  columns: {
    "id": "ID",
    "request_number": "ANFRAGE NR.",
    "name": "NAME",
    "actions": "AKTIONEN",
    "pib": "STEUERNR.",
    "status": "STATUS",
    "category": "KATEGORIE",
    "created_at": "ERSTELLT AM",
    "date_for_offer": "ANTWORTFRIST",
    "date_for_delivery": "LIEFERFRIST",
    "email": "E-MAIL",
    "role": "ROLLE",
    "budget": "BUDGET",
    "spent": "AUSGEGEBEN",
    "date_from": "DATUM VON",
    "date_to": "DATUM BIS",
    "join_date": "BEITRITTSDATUM",
    "activated_date": "AKTIVIERUNGSDATUM",
    "trial_period": "TESTZEITRAUM",
    "preorder": "VORRECHNUNG",
    "order": "RECHNUNG",
    "price": "PREIS",
    "package": "PAKET",
    "duration": "DAUER",
    "company": "FIRMA",
    "offer_status": "ANGEBOTSSTATUS",
    "sector": "SEKTOR",
    "accepted_supplier": "LIEFERANT",
    "payment": "ZAHLUNG"
  },
  fields: {
    "name": "Name",
    "email": "E-Mail",
    "emailOpt": "E-Mail (optional)",
    "password": "Passwort",
    "oldpassword": "Altes Passwort",
    "newpassword": "Neues Passwort",
    "companyName": "Firmenname",
    "pib": "Steuernummer",
    "nameAndSurname": "Vorname und Nachname",
    "phone": "Telefon",
    "passwordConfirm": "Passwort bestätigen",
    "privacyPolicy": "Nutzungsbedingungen",
    "description": "Beschreibung",
    "contactPerson": "Ansprechpartner",
    "category": "Kategorie",
    "categories": "Kategorien",
    "file": "Dateien",
    "price": "Preis",
    "supplier": "Lieferant",
    "suppliers": "Lieferanten",
    "total_price": "Gesamtpreis",
    "unit_price": "Einheitspreis",
    "date_for_offer": "Antwortfrist",
    "date_for_delivery": "Lieferfrist",
    "request_description": "Anforderungsbeschreibung",
    "offer_description": "Angebotsbeschreibung",
    "quantity": "Menge",
    "service": "Dienstleistung",
    "unit": "Einheit",
    "city": "Stadt",
    "companyAddress": "Firmenadresse",
    "role": "Rolle",
    "address": "Firmenadresse",
    "category_id": "Kategorie",
    "budget": "Budget",
    "date_from": "Datum von",
    "date_to": "Datum bis",
    "amount": "Betrag",
    "note": "Notiz",
    "offer_date": "Beschaffungsdatum",
    "addInvoice": "Rechnung hinzufügen",
    "sector": "Sektor",
    "additional_permissions": "Zusätzliche Berechtigungen",
    "message": "Nachricht",
    "internationalSupplier": "Ausländischer Lieferant"
  },
  validation: {
    ...de.messages,
    ... {
      "required_checkbox": "Das Feld {_field_} ist erforderlich",
      "array_length": "Das Feld {_field_} darf nicht länger als {array_length} Zeichen sein",
      "phone_validation": "Das Format von {_field_} ist ungültig. Gültiges Format +491234567890",
      "minmax": "Das Feld {_field_} muss zwischen {min} und {max} Ziffern enthalten",
      "exist": "{_field_} existiert bereits"
    }
  },
  filesValidation: "Erlaubte Dateiformate sind .xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png, die maximale Dateigröße beträgt 5 MB.",
}